import '../v1.2.0/css/globals-v120.css';
import { Fragment, useState, useEffect } from 'react';
import { Menu } from 'lucide-react';
import MobileNavigationDrawer440Bp from '../v1.2.0/ui/MobileNavigationDrawer440Bp';
import Vector from '../v1.2.0/ui/Vector-49-9109';

function Logo(): React.JSX.Element {
  return (
    <div className="h-[25px] w-[111.571px]">
      <Vector />
    </div>
  );
}

interface NavigationBarProps {
  onLogout: () => void;
  onNavigate: (page: string) => void;
}

export function NavigationBar({
  onLogout,
  onNavigate,
}: NavigationBarProps): React.JSX.Element {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = (): void => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return (): void => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-navigationbar sticky top-0 z-50">
      <div
        className="h-[60px] px-4 flex items-center justify-between bg-navigationbar bg-[rgba(252,252,252,1)] transition-shadow duration-200"
        style={{ boxShadow: isScrolled ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none' }}
      >
        {/* Mobile Layout */}
        <div className="flex items-center gap-4 min-[440px]:hidden w-full justify-between">
          <Logo />
          <button
            className="size-11 flex items-center justify-center rounded-[var(--radius)] transition-colors hover:bg-button-active active:bg-accent active:text-accent-foreground"
            aria-label="Menu"
            onClick={() => setIsDrawerOpen(true)}
          >
            <Menu className="size-6" />
          </button>
        </div>

        {/* Desktop Layout */}
        <div className="hidden min-[440px]:flex items-center justify-between w-full">
          <div className="flex items-center gap-4">
            <Logo />
            <nav className="flex items-center gap-4">
              <button
                className="h-8 px-5 hover:bg-button-hover rounded-[var(--radius-card)] transition-colors active:bg-button-active"
                onClick={() => onNavigate('/cases/library')}
              >
                Case Library
              </button>
            </nav>
          </div>
          <button
            className="h-8 px-5 hover:bg-button-active rounded-xl transition-colors"
            onClick={() => onLogout()}
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      {isDrawerOpen && (
        <Fragment>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/50 z-[60] min-[440px]:hidden"
            onClick={() => setIsDrawerOpen(false)}
          />

          {/* Drawer */}
          <div className="fixed top-0 left-0 bottom-0 w-[80vw] max-w-[359px] z-[70] min-[440px]:hidden">
            <MobileNavigationDrawer440Bp
              onNavigate={(page: string) => {
                setIsDrawerOpen(false);
                onNavigate(page);
              }}
            />
          </div>
        </Fragment>
      )}
    </div>
  );
}
